import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fromJS, List, Map } from "immutable";
import { createSelector } from "reselect";
export function cmsReducer() {
  var _action$payload, _action$payload2;
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case "CMS/CMS_PAGES_LIST_LOADED":
      return _objectSpread(_objectSpread({}, state), {}, {
        cmsPages: action.payload.cmsPages
      });
    case "CMS/CMS_PAGE_LOADED":
      var cms = {};
      cms[(_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.pageName] = (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.cmsPage;
      var newCms = Object.assign({}, state.cms, cms);
      return _objectSpread(_objectSpread({}, state), {}, {
        cms: newCms
      });
    default:
      return state;
  }
}
var getCmsPagesFromState = function getCmsPagesFromState(state) {
  var _state$cmsPages;
  return state === null || state === void 0 || (_state$cmsPages = state.cmsPages) === null || _state$cmsPages === void 0 ? void 0 : _state$cmsPages.cmsPages;
};
var getCmsPages = createSelector([getCmsPagesFromState], function (cmsPages) {
  return cmsPages ? fromJS(cmsPages) : List();
});
var getCmsPageNames = createSelector([getCmsPages], function (cmsPages) {
  return cmsPages.map(function (page) {
    return page.get("name");
  });
});
export var isValidPageName = createSelector([getCmsPageNames], function (cmsPageNames) {
  return function (pageName) {
    return cmsPageNames.includes(pageName);
  };
});

// this will return my object from the dispatch 
// cms[action.payload?.pageName] = fromJS(action.payload?.cmsPage);
var getCmsPagesByName = function getCmsPagesByName(state) {
  var _state$cmsPages2;
  return (state === null || state === void 0 || (_state$cmsPages2 = state.cmsPages) === null || _state$cmsPages2 === void 0 ? void 0 : _state$cmsPages2.cms) || Map();
};
var getPageName = function getPageName(state, _ref) {
  var pageName = _ref.pageName;
  return pageName;
};
export var getCmsPageTitle = createSelector([getCmsPagesByName, getPageName], function (cmsPagesByName, pageName) {
  return cmsPagesByName && cmsPagesByName[pageName] ? cmsPagesByName[pageName]["title"] : "";
});
export var getCmsPageContent = createSelector([getCmsPagesByName, getPageName], function (cmsPagesByName, pageName) {
  return cmsPagesByName && cmsPagesByName[pageName] ? cmsPagesByName[pageName]["content"] : "";
});